import { CatalogProductDetails } from './CatalogProductDetails';

export default CatalogProductDetails;
